import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import ForumOutlinedIcon from '@material-ui/icons/ForumOutlined';
import ViewQuiltOutlinedIcon from '@material-ui/icons/ViewQuiltOutlined'; 
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Profile, SidebarNav, UpgradePlan } from './components';
import COMMICON from '../../../../assets/images/COMM_V6_blue.svg' 
import PTMSG_BG from '../../../../assets/images/PTMSG_V2_blue.svg'
import SCHDICON from '../../../../assets/images/SCHD_blue.svg' 

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = props => {
  const { open, variant, onClose, className, profile, ...rest } = props;

  const classes = useStyles();

  const pages = [
    {
      title: 'Staff to Provider Communication',
      href: '/pt-issues',
      icon: <img src={COMMICON} width={25} height={25} style={{marginRight: 5, color: 'red'}} alt="COMM" />
    },
    {
      title: 'PT Schedule',
      href: '/pt-schedule',
      icon: <img src={SCHDICON} width={20} height={20} style={{marginRight: 5}} alt="SCHED" />
    },
    {
      title: 'Staff to Patient Communication',
      href: '/pt-message',
      icon: <img src={PTMSG_BG} width={25} height={25} style={{marginRight: 5}} alt="PT MESSAGE" />
    },
    {
      title: 'Templates',
      href: '/templates',
      icon: <ViewQuiltOutlinedIcon style={{width: 25, height: 25}}/>
    }
  ];

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}>
      <div {...rest} className={clsx(classes.root, className)}>
        <Profile profile={profile} />
        <Divider className={classes.divider} />
        <SidebarNav className={classes.nav} pages={pages} />
        {/* <UpgradePlan /> */}
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};
const mapDispatchToProps = {};

const mapStateToProps = state => ({
  profile: state.profile
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Sidebar)
);
